import { jsPDF } from 'jspdf';
import Logo from '../assets/GScom_logo.png';

export const generateReclamoPDF = async ({ legajo, nombre, mes, secuencia, motivo, firmaBase64, fechaProtesta }) => {
  try {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 20;
    const contentWidth = pageWidth - (margin * 2);

    // Colores corporativos
    const primaryColor = [236, 0, 140]; // Magenta de Grupo Sarmiento
    const secondaryColor = [50, 50, 50]; // Gris oscuro
    const lightGray = [240, 240, 240];

    // Header con fondo
    doc.setFillColor(...lightGray);
    doc.rect(0, 0, pageWidth, 45, 'F');

    // Logo - posicionado a la izquierda, más arriba
    const logoImg = new Image();
    logoImg.src = Logo;
    await new Promise(resolve => { logoImg.onload = resolve; });
    doc.addImage(logoImg, 'PNG', margin, 8, 40, 20);

    // Título principal - más a la derecha para no pisar el logo
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.setTextColor(...primaryColor);
    doc.text('RECLAMO POR DIFERENCIA DE HABERES', pageWidth / 2 + 10, 18, { align: 'center' });
    
    doc.setFontSize(10);
    doc.setTextColor(...secondaryColor);
    doc.text('Sres. Grupo Sarmiento', pageWidth / 2 + 10, 26, { align: 'center' });
    
    // Línea separadora
    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(0.5);
    doc.line(margin, 40, pageWidth - margin, 40);

    // Resetear color de texto
    doc.setTextColor(0, 0, 0);
    let yPosition = 50;

    // Sección: Datos del Empleado
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setFillColor(...lightGray);
    doc.rect(margin, yPosition, contentWidth, 8, 'F');
    doc.text('DATOS DEL EMPLEADO', margin + 2, yPosition + 5.5);
    yPosition += 12;

    // Datos en formato tabla
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    
    // Legajo y Nombre en dos columnas
    doc.setFont('helvetica', 'bold');
    doc.text('LEGAJO N°:', margin + 5, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(String(legajo), margin + 35, yPosition);
    
    yPosition += 7;
    doc.setFont('helvetica', 'bold');
    doc.text('APELLIDO Y NOMBRE:', margin + 5, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(nombre || 'Nombre no disponible', margin + 45, yPosition);
    
    yPosition += 7;
    doc.setFont('helvetica', 'bold');
    doc.text('MES RECLAMADO:', margin + 5, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(mes || 'N/A', margin + 40, yPosition);
    
    // Fecha del reclamo
    if (fechaProtesta) {
      yPosition += 7;
      doc.setFont('helvetica', 'bold');
      doc.text('FECHA DEL RECLAMO:', margin + 5, yPosition);
      doc.setFont('helvetica', 'normal');
      const fecha = new Date(fechaProtesta);
      const fechaFormateada = fecha.toLocaleDateString('es-AR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
      doc.text(fechaFormateada, margin + 50, yPosition);
    }

    yPosition += 15;

    // Sección: Motivo del Reclamo
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setFillColor(...lightGray);
    doc.rect(margin, yPosition, contentWidth, 8, 'F');
    doc.text('MOTIVO DEL RECLAMO', margin + 2, yPosition + 5.5);
    yPosition += 12;

    // Texto del motivo
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text('Solicito por medio de la presente se me abone la diferencia de haberes', margin + 5, yPosition);
    yPosition += 6;
    doc.text(`correspondiente al mes de ${mes}, motivada por:`, margin + 5, yPosition);
    yPosition += 10;

    // Recuadro para el motivo
    const motivoLines = doc.splitTextToSize(motivo || 'Motivo no especificado', contentWidth - 10);
    const motivoHeight = motivoLines.length * 6 + 10;
    
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.rect(margin + 5, yPosition - 5, contentWidth - 10, motivoHeight);
    
    doc.setFont('helvetica', 'normal');
    doc.text(motivoLines, margin + 8, yPosition);
    yPosition += motivoHeight + 15;

    // Sección: Espacio para Resolución
    if (yPosition > pageHeight - 100) {
      doc.addPage();
      yPosition = 20;
    }

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setFillColor(...lightGray);
    doc.rect(margin, yPosition, contentWidth, 8, 'F');
    doc.text('RESOLUCIÓN ADMINISTRATIVA', margin + 2, yPosition + 5.5);
    yPosition += 15;

    // Espacio para resolución
    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.3);
    doc.rect(margin + 5, yPosition, contentWidth - 10, 35);
    
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(9);
    doc.setTextColor(150, 150, 150);
    doc.text('Espacio reservado para la resolución del reclamo', margin + 8, yPosition + 5);
    doc.setTextColor(0, 0, 0);
    yPosition += 65;

    // Firmas finales
    const firmaWidth = 70;
    const firmaSpacing = (contentWidth - (firmaWidth * 2)) / 3;
    
    // Firma del empleado (izquierda)
    const firmaEmpleadoX = margin + firmaSpacing;
    
    // Si hay firma digital, mostrarla arriba de la línea
    if (firmaBase64) {
      try {
        console.log('🖊️ Intentando cargar firma para sección final...');
        
        const firmaImg = new Image();
        firmaImg.src = `data:image/png;base64,${firmaBase64}`;
        
        await new Promise((resolve, reject) => {
          firmaImg.onload = () => {
            console.log('✅ Firma cargada correctamente');
            resolve();
          };
          firmaImg.onerror = (err) => {
            console.error('❌ Error al cargar imagen de firma:', err);
            reject(err);
          };
        });
        
        // Agregar la firma ARRIBA de la línea - más pequeña
        doc.addImage(firmaImg, 'PNG', firmaEmpleadoX + 5, yPosition - 22, 60, 18);
        
        console.log('✅ Firma agregada al PDF');
      } catch (error) {
        console.error('❌ Error procesando firma:', error);
      }
    }
    
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.line(firmaEmpleadoX, yPosition, firmaEmpleadoX + firmaWidth, yPosition);
    doc.text('Firma del Empleado', firmaEmpleadoX + (firmaWidth / 2), yPosition + 5, { align: 'center' });
    
    // Firma de Grupo Sarmiento (derecha)
    const segundaFirmaX = margin + firmaSpacing + firmaWidth + firmaSpacing;
    doc.line(segundaFirmaX, yPosition, segundaFirmaX + firmaWidth, yPosition);
    doc.text('Firma Autorizada Grupo Sarmiento', segundaFirmaX + (firmaWidth / 2), yPosition + 5, { align: 'center' });

    // Footer
    yPosition = pageHeight - 15;
    doc.setDrawColor(...primaryColor);
    doc.setLineWidth(0.5);
    doc.line(margin, yPosition, pageWidth - margin, yPosition);
    
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    const fechaGeneracion = new Date().toLocaleDateString('es-AR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
    doc.text(`Documento generado el ${fechaGeneracion}`, pageWidth / 2, yPosition + 5, { align: 'center' });
    doc.text(`Reclamo N° ${secuencia || 'S/N'} - Legajo ${legajo}`, pageWidth / 2, yPosition + 9, { align: 'center' });

    // Generar el PDF
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);

    return {
      blob: pdfBlob,
      url: pdfUrl
    };

  } catch (error) {
    console.error('Error al generar el PDF del reclamo:', error);
    throw error;
  }
};
